import type { RecordingEntrySurface } from '@/tauri/rpa-recorder/types';

export const RECORDER_ENTRY_SURFACE = {
  OVERLAY: 'overlay',
  DESKTOP_APP: 'desktopApp',
} as const satisfies Record<string, RecordingEntrySurface>;
